import React, {memo} from "react";
import {NESTED_NODE_HORIZONTAL_MARGIN} from "../../stylingConstants";
import styled from '@emotion/styled';
import {Control} from "rete-react-render-plugin";

const StyledTimeLimitContainerDiv = styled.div`
  padding: 16px 0px;
  margin-left: ${NESTED_NODE_HORIZONTAL_MARGIN};
  margin-right: ${NESTED_NODE_HORIZONTAL_MARGIN};
`;

const TimeLimit = ({controls, bindControl, isNodeCollapsed}) => {

    if (controls.length === 0 || isNodeCollapsed) return null;
    const timeLimitControl = controls[0];

    return (
        <StyledTimeLimitContainerDiv>
            <Control key={timeLimitControl.key} control={timeLimitControl} innerRef={bindControl} />
        </StyledTimeLimitContainerDiv>
    );
}

export default memo(TimeLimit)